import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import "../../assets/Styles/User.css";
import Pagination from "../../components/common/pagination";
import Loader, { SwitchLoader } from "../../Loader/Loader";
import {
  EyeIcon,
  LockOpen,
  Search,
  ToggleLeft,
  ToggleRight,
  Trash,
  UserLock,
} from "lucide-react";
import {
  blockunblockuser,
  deleterestoreuser,
  suspendeduser,
  userlist,
} from "../../services/Mainservice";
import Deletepopup from "../../components/common/Aresure";

const UserList = () => {
  const [loading, setloading] = useState(true);
  const [onload, setonload] = useState({ block: false, suspend: false });
  const [data, setData] = useState([]);
  const [value, setvalue] = useState("all");
  const [searchvalue, setsearchvalue] = useState();
  const [pagination, setpagination] = useState({ page: 1 });
  const navigate = useNavigate();
  const [showdelete, setshowdelete] = useState(false);
  const [id, setid] = useState(false);

  useEffect(() => {
    getData(pagination.page);
  }, []);
  console.log(onload);

  useEffect(() => {
    getData(1);
  }, [searchvalue, value]);

  const getData = async (page) => {
    try {
      const response = await userlist(page, searchvalue, value);
      console.log(response.data);
      setData(response.data.data);
      setpagination(response.data.pagination);
      setloading(false);
    } catch (error) {
      setloading(false);
      if (error.code === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };
  const handleblock = async (id, value) => {
    try {
      setonload((prev) => ({
        ...prev,
        block: { ...prev.block, [id]: true },
      }));
      const response = await blockunblockuser(id, value);
      setonload((prev) => ({
        ...prev,
        block: { ...prev.block, [id]: false },
      }));
      getData("1");
    } catch (error) {
      setonload((prev) => ({
        ...prev,
        block: { ...prev.block, [id]: false },
      }));
      setloading(false);
      if (error.code === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };
  const handlesuspended = async (id, value) => {
    try {
      setonload((prev) => ({
        ...prev,
        suspend: { ...prev.suspend, [id]: true },
      }));
      // set
      const response = await suspendeduser(id, value);
      setonload((prev) => ({
        ...prev,
        suspend: { ...prev.suspend, [id]: false },
      }));
      console.log(response.data);
      getData("1");
      setloading(false);
    } catch (error) {
      setonload((prev) => ({
        ...prev,
        suspend: { ...prev.suspend, [id]: false },
      }));
      setloading(false);
      if (error.code === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };
  const handledelete = async () => {
    try {
      const response = await deleterestoreuser(id);
      setsearchvalue();
      getData("1");
      setloading(false);
      setshowdelete(false);
    } catch (error) {
      setloading(false);
      if (error.code === 401) {
        localStorage.clear();
        navigate("/");
      }
    }
  };

  return (
    <>
      <div className="container1">
        <div className="data_head">
          <h1 className="data_heading">All User List</h1>

          <div className="searchicon">
            <Search style={{ color: "var(--blurwhite)" }} />{" "}
            <input
              type="search"
              placeholder="Search..."
              id="search"
              onChange={(e) => setsearchvalue(e.target.value)}
              autoComplete="off"
            />
          </div>
        </div>
        <select
          className="filterselect"
          value={value}
          onChange={(e) => {
            setvalue(e.target.value);
            setpagination((prev) => ({ ...prev, page: 1 }));
          }}
        >
          <option value="all">All Users</option>
          <option value="block">Blocked</option>
          <option value="suspended">Suspended</option>
          <option value="deleted">Deleted Users</option>
        </select>{" "}
        <br />
        <div className="data_table_over">
          <table className="data_table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Date</th>
                <th>Profile Status</th>
                <th>Block</th>
                <th>Suspended</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {data?.map((item) => (
                <tr key={item.id}>
                  <td>{item.FirstName}</td>
                  <td>{item.email}</td>
                  <td>{item?.createdAt?.split("T")[0]}</td>
                  <td>
                    {item.isCompletedProfile === false ? (
                      <span className="cancel_data">Incomplete</span>
                    ) : (
                      <span className="complete_data">Complete</span>
                    )}
                  </td>

                  <td>
                    {" "}
                    {onload.block[item.id] ? (
                      <SwitchLoader />
                    ) : item.isBlock ? (
                      <ToggleRight
                        style={{ color: "var(--red" }}
                        onClick={() => handleblock(item.id, false)}
                      />
                    ) : (
                      <ToggleLeft onClick={() => handleblock(item.id, true)} />
                    )}
                  </td>
                  <td>
                    {onload.suspend[item.id] ? (
                      <SwitchLoader />
                    ) : item.isSuspend ? (
                      <ToggleRight
                        style={{ color: "#3b6ad8" }}
                        onClick={() => handlesuspended(item.id, false)}
                      />
                    ) : (
                      <ToggleLeft
                        onClick={() => handlesuspended(item.id, true)}
                      />
                    )}
                  </td>
                  <td>
                    <div className="user_actionicon">
                      <EyeIcon
                        onClick={() =>
                          navigate("/User_Details", {
                            state: {
                              data: item,
                            },
                          })
                        }
                      />

                      <Trash
                        onClick={() => {
                          setid(item.id);
                          setshowdelete(true);
                        }}
                      />
                    </div>
                  </td>

                  {/* <td>
                    {item.screen === "7" ? (
                      <span className="cancel_data">Rejected</span>
                    ) : item.screen === "6" ? (
                      <span className="complete_data">Aproved</span>
                    ) : item.screen === "5" ? (
                      <span className="pending_data">Under Review</span>
                    ) : item.screen === "9" ? (
                      <span className="cancel_data">Blocked</span>
                    ) : (
                      <span className="cancel_data">Incomplete</span>
                    )}
                  </td> */}
                  {/* <td>
                    <button
                      onClick={() => navigate("/User_Details")}
                      className="data_button_view"
                    >
                      View
                    </button>
                  </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>{" "}
        <Pagination pagedata={pagination} onPageChange={getData} />
      </div>
      {loading && <Loader />}
      <Deletepopup
        isOpen={showdelete}
        setisOpen={setshowdelete}
        handleDelete={handledelete}
        onClose={() => setshowdelete(false)}
      />
    </>
  );
};
export default UserList;
